import Axios, { type AxiosInstance } from 'axios';
import { CommonHeaders, getCommonHeaders } from '../client/utilities.client-helper';
import { isProduction } from './environment';

let axios: AxiosInstance | undefined;

function configureAxios() {
  if (isProduction()) {
    return Axios.create({
      baseURL: 'https://api.justo.cloud/op-scanner/',
    });
  }

  return Axios.create({
    baseURL: 'https://stag.justo.cloud/op-scanner/',
  });
}

function getAxiosInstance(): AxiosInstance {
  if (!axios) {
    axios = configureAxios();

    axios.interceptors.request.use(async config => {
      const headers: CommonHeaders = await getCommonHeaders();
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.entries(headers).forEach(([key, value]) => {
        config.headers.set(key, value);
      });
      return config;
    });
  }

  return axios;
}

export const scannerAxiosInstance = getAxiosInstance;
